import React from 'react'

export type PostMessageHandler = (payload: unknown, event: MessageEvent) => void

type Options = {
  enabled: boolean
  allowedOrigin?: string
  requiredSource?: string
  iframeRef?: React.RefObject<HTMLIFrameElement>
  handlers: Record<string, PostMessageHandler>
}

export const usePostMessageRouter = ({ enabled, allowedOrigin, requiredSource = 'creately', iframeRef, handlers }: Options) => {
  React.useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (!enabled) return
      if (allowedOrigin && e.origin !== allowedOrigin) return
      if (iframeRef?.current && e.source !== iframeRef.current.contentWindow) return
      let msg: unknown = e.data
      if (typeof msg === 'string') {
        try { msg = JSON.parse(msg) } catch { return }
      }
      type GenericMessage = { event?: string; source?: string; data?: unknown }
      if (
        msg && typeof msg === 'object' &&
        'data' in (msg as Record<string, unknown>) &&
        typeof (msg as Record<string, unknown>).data === 'string'
      ) {
        try {
          (msg as Record<string, unknown>).data = JSON.parse((msg as Record<string, unknown>).data as string)
        } catch { return }
      }
      const data = msg as GenericMessage
      if (!data || data.source !== requiredSource || !data.event) return
      const handler = handlers[data.event]
      if (!handler) return
      handler(data.data, e)
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [enabled, allowedOrigin, requiredSource, iframeRef, handlers])
}


